import React, { useState, useRef } from "react";
import { isEmpty } from "lodash";
import NoDataImg from "../../../assets/img/NoDataImg.svg";
import NoImg from "../../../assets/img/NoImg.svg";
import brokenImg from "../../../assets/img/brokenImg.svg";
import style from "./Image.module.scss";

interface ImageProps {
  src: string | undefined;
  alt?: string;
  defaultClass?: string;
  bigSize?: boolean;
  isSquare?: boolean;
}

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  defaultClass,
  bigSize,
  isSquare,
}) => {
  const ref = useRef<HTMLImageElement | null>(null);
  const [errorImage, setErrorImage] = useState(false);

  const loadImageError = () => {
    setErrorImage(true);
  };

  const [imgHeight, setImgHeight] = useState(ref.current?.offsetWidth);

  React.useEffect(() => {
    setImgHeight(ref.current?.offsetWidth);
    window.addEventListener("resize", () => {
      setImgHeight(ref.current?.offsetWidth);
    });
  }, [ref.current]);

  React.useEffect(() => {
    if (isSquare && imgHeight) {
      ref.current?.setAttribute("height", `${imgHeight}px`);
    }
  }, [ref.current, isSquare, imgHeight]);

  return (
    <>
      {src ? (
        <img
          ref={ref}
          alt={alt || ""}
          src={errorImage ? brokenImg : src}
          className={`${defaultClass} ${
            (errorImage || isEmpty(src)) && style.noImage
          }`}
          onError={loadImageError}
        />
      ) : (
        <img
          ref={ref}
          alt="NoImg"
          src={bigSize ? NoDataImg : NoImg}
          className={`${defaultClass} ${style.noImage} "no-img"`}
        />
      )}
    </>
  );
};

export default Image;
